import { ACTION_TYPES } from "@Redux";
import React from "react";
import { useDispatch } from "react-redux";
import { IUpsellListings } from "../components/Interfaces";

// setting these props to reducer because need to use these propes in UserDetail modal and to avoid prop drilling
export const useSetUpsellListingProps = ({
    upsellListingsProps,
}: {
    upsellListingsProps: IUpsellListings.IProps;
}) => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch({
            type: ACTION_TYPES.PROPS.COMPONENT_PROPS
                .UPDATE_UPSELL_COMPONENT_PROPS,
            payload: upsellListingsProps,
        });
    }, [upsellListingsProps]);
};
